import { useState } from "react";
import { useAuth } from "@/lib/AuthContext";
import { api, ROLE_LABELS, ROLE_COLORS } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Save } from "lucide-react";
import { toast } from "sonner";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({
    hex_id: user.hex_id, display_name: user.display_name || "", bio: user.bio || "",
  });

  const save = async () => {
    try { await api.put("/users/me", form); toast.success("Profil güncellendi"); refresh(); }
    catch (e) { toast.error(e.response?.data?.detail || "Başarısız"); }
  };

  return (
    <div className="p-6 md:p-10 max-w-2xl space-y-6">
      <header>
        <div className="text-[11px] font-mono text-rose-500 tracking-widest mb-2">// IDENTITY</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">Profil</h1>
        <p className="text-zinc-500 mt-2">Kendi bilgilerini güncelle.</p>
      </header>

      <Card className="bg-zinc-950 border-zinc-900 p-6 space-y-4">
        <div className="flex items-center gap-4 pb-4 border-b border-zinc-900">
          {user.discord_avatar && <img src={user.discord_avatar} alt="" className="w-16 h-16 rounded-full" />}
          <div>
            <div className="font-heading text-xl font-semibold">{user.discord_username}</div>
            <div className="font-mono text-xs text-zinc-500">{user.discord_id}</div>
            <div className={`text-[10px] font-mono px-2 py-0.5 mt-2 inline-block border ${ROLE_COLORS[user.role]}`}>{ROLE_LABELS[user.role]}</div>
          </div>
        </div>

        <div><Label className="text-xs font-mono">HEX ID</Label>
          <Input value={form.hex_id} onChange={e=>setForm({...form,hex_id:e.target.value})} data-testid="profile-hex-input" className="bg-zinc-900 border-zinc-800 mt-1.5 font-mono" /></div>
        <div><Label className="text-xs font-mono">GÖSTERİM ADI</Label>
          <Input value={form.display_name} onChange={e=>setForm({...form,display_name:e.target.value})} data-testid="profile-display-input" className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>
        <div><Label className="text-xs font-mono">BIO</Label>
          <Textarea rows={3} value={form.bio} onChange={e=>setForm({...form,bio:e.target.value})} data-testid="profile-bio-input" className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>

        <Button onClick={save} data-testid="profile-save-button" className="bg-rose-600 hover:bg-rose-700">
          <Save className="w-4 h-4 mr-2" /> Kaydet
        </Button>
      </Card>
    </div>
  );
}
